import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute component - ensures user is authenticated before accessing protected routes
 * Checks for valid token in localStorage and redirects to login if not found
 */
const ProtectedRoute = ({ children }) => {
  const token = window.localStorage.getItem("token");
  const user = window.localStorage.getItem("user");
  
  // Check if user is authenticated
  const isAuthenticated = token && token !== "undefined" && token !== "" && user;
  
  if (!isAuthenticated) {
    // Redirect to login page if not authenticated
    return <Navigate to="/login" replace />;
  }
  
  // Render the protected component if authenticated
  return children;
};

export default ProtectedRoute;
